import { render, staticRenderFns } from "./CollectionsBottomBar.vue?vue&type=template&id=ee55fc3a&scoped=true&"
import script from "./CollectionsBottomBar.vue?vue&type=script&lang=js&"
export * from "./CollectionsBottomBar.vue?vue&type=script&lang=js&"
import style0 from "./CollectionsBottomBar.vue?vue&type=style&index=0&id=ee55fc3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee55fc3a",
  null
  
)

export default component.exports